import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { isFunction } from "lodash-es";

import { _GLOBAL_LAZY_IMAGE_CONFIG, GLOBAL_LAZY_IMAGE_CONFIG } from "./const";
import { LazyImageComponent } from "./lazy-image/lazy-image.component";
import { LazyImageConfig } from "./model";

export const GLOBAL_LAZY_IMAGE_DIRECTIVES: any[] = [LazyImageComponent];

@NgModule({
	imports: [CommonModule],
	exports: GLOBAL_LAZY_IMAGE_DIRECTIVES,
	declarations: GLOBAL_LAZY_IMAGE_DIRECTIVES,
})
export class GlobalUiLazyImageModule {
	/**
	 * Call `GlobalUiLazyImageModule.forRoot` in your application module.
	 *
	 * @param config Config is required, specify it in `forRoot` or alternatively using `GLOBAL_LAZY_IMAGE_CONFIG` token to utilize DI.
	 */
	static forRoot(config?: LazyImageConfig | (() => LazyImageConfig)): ModuleWithProviders<GlobalUiLazyImageModule> {
		return {
			ngModule: GlobalUiLazyImageModule,
			providers: [
				{
					provide: GLOBAL_LAZY_IMAGE_CONFIG,
					useFactory: _lazyImageConfigFactory,
					deps: [_GLOBAL_LAZY_IMAGE_CONFIG],
				},
				{ provide: _GLOBAL_LAZY_IMAGE_CONFIG, useValue: config },
			],
		};
	}
}

/**
 * @internal
 */
export function _lazyImageConfigFactory(config?: LazyImageConfig | (() => LazyImageConfig)) {
	return isFunction(config) ? config() : config;
}
